import { FC } from 'react';
import closeIcon from 'images/close-icon-black.svg';

interface CloseIconBlackProps {
  onClick: () => void;
}

const CloseIconBlack: FC<CloseIconBlackProps> = props => {
  const { onClick } = props;
  return (
    <img
      data-testid="close-icon"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      src={closeIcon}
      alt="close-icon-black"
    />
  );
};
export default CloseIconBlack;
